import axios from 'axios';

const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000, // Add reasonable timeout to prevent hanging requests
});

// Add response interceptor for better error handling
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        // Simply log and let Sentry capture it automatically
        console.error('API request failed:', error.message);
        return Promise.reject(error);
    }
);

export default axiosInstance;